import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../../../../types/upload-field'
import PrivacyField from '../../../../../form-fields/upload/privacy'
import { CreationCaptureInfoContext } from '../manager'

const Privacy = styled(PrivacyField)`
    grid-column: span 1;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationCaptureInfoPrivacyField = ({ className, field }: Props) => {
    const { isPublic, setIsPublic } = useContext(CreationCaptureInfoContext)

    return (
        <Privacy
            {...{
                className,
                field,
                isPublic,
                onChange: setIsPublic,
            }}
        />
    )
}

export default CreationCaptureInfoPrivacyField
